import { safeJoin } from '@/common/utils';
import { useCurrentUser } from '@/hooks';
import { useCurrentUserSubscription } from '@/hooks/use-current-user-subscription';
import { usePrizeEntryCount } from '@/hooks/use-prize-entry-count';
import { ActionIcon, Avatar, Button, Flex, Text, useMantineTheme } from '@mantine/core';
import { IconEdit, IconStar, IconTrophy, IconUserBolt } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import styles from './styles.module.css';

export const User = () => {
	const { currentUser } = useCurrentUser();
	const { currentUserSubscription } = useCurrentUserSubscription();
	const { monthlyCount, yearlyCount } = usePrizeEntryCount();

	const navigate = useNavigate();
	const { colors } = useMantineTheme();

	return (
		<Flex direction="row" align="center" justify="space-between" w="100%" className={styles.root}>
			<Flex align="center" gap="md">
				<Avatar size="lg" radius="xl" className={styles.avatar}>
					<IconUserBolt size={32} color="black" />
				</Avatar>
				<Flex direction="column" align="flex-start" justify="space-between" gap="xs">
					<Text size="md" fw={900}>
						{safeJoin([currentUser?.contact?.firstName, currentUser?.contact?.lastName], ' ')}
					</Text>
					{currentUserSubscription?.name ? (
						<Flex
							direction="row"
							align="center"
							gap="xs"
							style={{
								color: currentUserSubscription?.metadata?.background_colour ?? colors.orange[1],
							}}
						>
							<IconStar size={24} />
							<Text size="sm" fw={400}>
								{currentUserSubscription?.name}
							</Text>
						</Flex>
					) : (
						<Button onClick={() => navigate({ to: '/choose-subscription' })}>
							Add subscription
						</Button>
					)}
					{(monthlyCount > 0 || yearlyCount > 0) && (
						<Flex direction="row" align="center" gap="xs">
							<IconTrophy size={24} />
							<Text size="sm" fw={400}>
								{monthlyCount} Monthly, {yearlyCount} yearly
							</Text>
						</Flex>
					)}
				</Flex>
			</Flex>
			<ActionIcon
				aria-label="Edit account"
				bg="white"
				c="green.1"
				onClick={() => navigate({ to: '/account' })}
			>
				<IconEdit size={32} />
			</ActionIcon>
		</Flex>
	);
};
